import { isAdmin, isAnyAdmin } from 'permissions/v1/roles';

const list = (profile) => isAnyAdmin(profile);
const view = (profile) => isAnyAdmin(profile);
const create = (profile) => isAdmin(profile);
const update = (profile) => isAdmin(profile);
const destroy = (profile) => isAdmin(profile);

const permissions = (profile) => {
  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
  };
};

export default permissions;
